import { ApolloClient } from 'react-apollo';
import { SubscriptionClient } from 'subscriptions-transport-ws';
import { addGraphQLSubscriptions } from 'add-graphql-subscriptions';
import { PersistedQueryNetworkInterface } from 'persistgraphql';

import { persistedQueries as queryMap } from '@simple-city/service-graphql-schemas';
import pkgJson from '../../package.json';

const { config: { graphQlUri: { host: tld } } } = pkgJson;

const { REACT_APP_ENV_PREFIX: envPrefix = '' } = process.env;
const { __APOLLO_STATE__: initialState = {} } = window; // eslint-disable-line no-underscore-dangle

// networkInterfaceOptions
const networkInterfaceOptions = {
  credentials: 'same-origin',
  headers: {
    'x-graphql-persisted': true,
  },
};

const prefix = envPrefix ? `${envPrefix}-` : '';
const protocol = envPrefix === 'local' ? 'http' : 'https';
const wsProtocol = envPrefix === 'local' ? 'ws' : 'wss';
const webPort = envPrefix === 'local' ? ':8080' : '';
const wsPort = envPrefix === 'local' ? ':8091' : '';
const baseUri = `${prefix}graphql.${tld}`;

const networkInterfaceSansSubscriptions = new PersistedQueryNetworkInterface({
  queryMap,
  uri: `${protocol}://${baseUri}${webPort}/graphql`,
  opts: { ...networkInterfaceOptions },
  enablePersistedQueries: true,
});

const middlewares = [
  {
    applyMiddleware: (req, next) => {
      if (!req.options.headers) {
        req.options.headers = {}; // Create the header object if needed.
      }

      // get the authentication token from local storage if it exists
      const token = localStorage.getItem('id_token');

      req.options.headers = {
        ...(req.options.headers || {}),
        authorization: token ? `Bearer ${token}` : null,
      };

      next();
    },
  },
];

networkInterfaceSansSubscriptions.use(middlewares);

// Create WebSocket client
const wsClient = new SubscriptionClient(`${wsProtocol}://${baseUri}${wsPort}/ws`, {
  reconnect: true,
});

const networkInterface = addGraphQLSubscriptions(networkInterfaceSansSubscriptions, wsClient);

const ssrForceDelay = 100;

const apolloClientOptions = {
  networkInterface,
  initialState,
  ssrForceDelay,
};

export default overrides => new ApolloClient({ ...apolloClientOptions, ...overrides });



// WEBPACK FOOTER //
// ./src/lib/apolloClient.js